import { IMRealStateProduct } from '~/models/RealEstateProduct';
import { Mock } from './Mock';
import { Project } from './Project';

export const Box = {
  Project: (args: IMRealStateProduct): JSX.Element => <Project {...args} />,
  Mock: (): JSX.Element => <Mock />,
};
